import { getNotificationBarHostId } from 'owa-timestream-store';
import { lazyShowNotification } from 'owa-notification-bar';

export default function showNotification(actionName: string, messageString: string) {
    const notificationBarHostId = getNotificationBarHostId();

    lazyShowNotification.importAndExecute(actionName, notificationBarHostId, messageString);
}
